import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {datetime} from "@atttomyx/shared-utils";

const TypeCard = (props) => {
    const { type, filters, children } = props;

    return <Card className="type-card" raised={true}>
        <CardContent>
            <CardTitle>
                {type.title}
            </CardTitle>
            <CardData
                filters={filters}
                data={type}
                keyToMetadata={{
                    roles: {
                        title: "Roles",
                        hidden: type.roles.length === 0,
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default TypeCard;
